import script from "./EventActionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EventActionModal.vue?vue&type=script&setup=true&lang=js"

import "./EventActionModal.vue?vue&type=style&index=0&id=8e344f7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e344f7c"]])

export default __exports__